import { Component, inject } from "@angular/core";
import { MAT_OVERLAY_DATA, OverlayPopupRef } from "../../../core";

@Component({
    selector: "app-list-overlay",
    templateUrl: "./list-overlay.component.html",
    styleUrls: ["./list-overlay.component.scss"]
})
export class ListOverlayComponent {
  dialogRef = inject<OverlayPopupRef<ListOverlayComponent>>(OverlayPopupRef);
  inputdata = inject(MAT_OVERLAY_DATA);

  public listItems: string[];
  private readonly featureToken = "bucket-items";
  private readonly surfaceToken = "list-overlay";
  constructor() {
    const inputdata = this.inputdata;

    this.listItems = inputdata;
  }

  itemClick(item:string) {
    this.dialogRef.close(item);
  }

  public buildOverlayId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContextToken(context));
    }
    return tokens.join('-');
  }

  private formatContextToken(value: string | number): string {
    if (typeof value === 'number') {
      return value.toString().padStart(2, '0');
    }
    if (typeof value === 'string' && value.trim().length > 0) {
      return this.slugify(value);
    }
    return '00';
  }

  private slugify(value: string): string {
    return (value || 'na')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }
}
